var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrownAmbassador(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 120 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12_2109)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120 100V0.499992C120 0.223854 119.776 0 119.5 0L98.4809 6.68791C97.8451 6.89018 97.1601 6.87479 96.5341 6.64416L79.1825 0.251459C78.7416 0.0890243 78.2576 0.0870054 77.8154 0.245756L60.0409 6.62634C59.3691 6.86751 58.6333 6.86123 57.9656 6.60862L41.1985 0.264281C40.748 0.0938411 40.2512 0.0916697 39.7993 0.258167L22.4932 6.6341C21.8505 6.87088 21.1461 6.88061 20.4971 6.66167L0.750003 0C0.335788 0 0 0.335783 0 0.749998V100C0 133.137 26.8629 160 60 160C93.1371 160 120 133.137 120 100Z",
    fill: "#8B88A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116 100V4.49999C116 4.22385 115.776 4 115.5 4L98.5586 10.5883C97.8765 10.8536 97.1209 10.8603 96.4342 10.6073L79.1825 4.25146C78.7416 4.08902 78.2576 4.08701 77.8154 4.24576L60.0409 10.6263C59.3691 10.8675 58.6333 10.8612 57.9656 10.6086L41.1985 4.26428C40.748 4.09384 40.2512 4.09167 39.7993 4.25817L22.6062 10.5925C21.8952 10.8544 21.1114 10.8376 20.4123 10.5454L4.75 4C4.33579 4 4 4.33578 4 4.75V100C4 130.928 29.0721 156 60 156C90.9279 156 116 130.928 116 100Z",
    fill: "#C1BDD5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 20H111V100C111 128.167 88.1665 151 60 151C31.8335 151 9 128.167 9 100V20Z",
    fill: "url(#paint0_linear_12_2109)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111 28V12.4372C111 12.1958 110.804 12 110.563 12L96.9643 16.0596C96.3335 16.248 95.6581 16.2235 95.0425 15.9901L77.3765 9.29111C76.8846 9.10459 76.339 9.11937 75.858 9.33226L61.1533 15.8396C60.4157 16.166 59.5777 16.1817 58.8285 15.8831L42.2789 9.28694C41.8157 9.10233 41.3003 9.09739 40.8337 9.27309L23.0596 15.9654C22.3997 16.2138 21.6734 16.2219 21.0081 15.9882L9.65589 12C9.29365 12 9 12.2937 9 12.6559V28L57.4411 40.8226C59.1181 41.2666 60.8819 41.2666 62.5589 40.8226L111 28Z",
    fill: "#8B87A7"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 119.643L35 84.8214H44.4595L60 105.357V119.643Z",
    fill: "#CCCCCC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60 50L35 84.8214H44.4595L60 64.2857V50Z",
    fill: "#F8F8F8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60 119.643L85 84.8214H75.5405L60 105.357V119.643Z",
    fill: "#9F9F9F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60 50L85 84.8214H75.5405L60 64.2857V50Z",
    fill: "#CCCCCC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4727 84.8202L60.0132 64.2845L75.5537 84.8202L60.0132 105.356L44.4727 84.8202Z",
    fill: "#E6E6E6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5 128.061L76 112.03H80.3514L87.5 121.484V128.061Z",
    fill: "#CCCCCC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5 96L76 112.03H80.3514L87.5 102.577V96Z",
    fill: "#F8F8F8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5 128.061L99 112.03H94.6486L87.5 121.484V128.061Z",
    fill: "#9F9F9F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5 96L99 112.03H94.6486L87.5 102.577V96Z",
    fill: "#CCCCCC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3574 112.03L87.5061 102.576L94.6547 112.03L87.5061 121.484L80.3574 112.03Z",
    fill: "#E6E6E6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 128.061L21 112.03H25.3514L32.5 121.484V128.061Z",
    fill: "#CCCCCC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 96L21 112.03H25.3514L32.5 102.577V96Z",
    fill: "#F8F8F8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 128.061L44 112.03H39.6486L32.5 121.484V128.061Z",
    fill: "#9F9F9F"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 96L44 112.03H39.6486L32.5 102.577V96Z",
    fill: "#CCCCCC"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3574 112.03L32.5061 102.576L39.6547 112.03L32.5061 121.484L25.3574 112.03Z",
    fill: "#E6E6E6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12_2109",
    x1: 60,
    y1: 20,
    x2: 60,
    y2: 151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#726F89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#352042"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12_2109"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 160,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrownAmbassador);
export default __webpack_public_path__ + "static/media/crownAmbassador.9fa6f38aabbbb40f4a81646a5b5a8fb1.svg";
export { ForwardRef as ReactComponent };